<template>
  <div class="bg-[#1c1e1f] h-[100vh] w-[100vw] flex items-center loading">
    <!-- <div class="text-white text-2xl text-center rtl:ml-4 ltr:mr-4">
      {{ content.loading }}
    </div> -->
    <div class="w-[100vw]">
      <div class="relative mt-8 gird place-content-center h-[28px] w-[100vw]">
        <div class="h-[1px] w-full bg-white bg-opacity-10 absolute"></div>
        <div
          class="
            w-4
            h-[1px]
            bg-white
            top-0
            absolute
            transition-all
            loading-line
          "
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["content"],
};
</script>
<style scoped>
.loading-line {
  animation: loading-line 3s forwards;
}
.loading-line {
  left: 0;
}
.rtl .loading-line {
  left: unset !important;
  right: 0;
}
/* .loading {
  padding-inline-start: 3vw;
} */
@keyframes loading-line {
  0% {
    width: 0%;
  }
  25% {
    width: 20%;
  }
  45% {
    width: 45%;
  }

  100% {
    width: 100%;
  }
}
</style>
